<template>
  <b-modal
    :title="`${props.claim?.worker_name?.split(' ')[0]}'s profile`"
    :title-class="['text-center', 'w-100', 'font-weight-bold']"
    :body-class="['p-0', 'rounded-bottom']"
    :id="'candidate_profile_' + props.claim.worker_id"
    hide-footer
    no-close-on-backdrop
    no-close-on-escape
    centered
    size="lg"
    ref="modal"
  >
    <WorkerProfile :claim="props.claim" @claim-selected="approveClaim" />
  </b-modal>
</template>

<script setup>
import { ref } from 'vue';
import ApiClient from '@/ApiClient';
import { getShiftsForTab } from '@/state/composables/useTalentPoolShifts';
import WorkerProfile from '@/pages/talent-pool/components/WorkerProfile.vue';
import { useRoute, useRouter } from 'vue-router/composables';

const route = useRoute();
const router = useRouter();
const locationId = route.params.locationId;
const tab = route.params.tab;

const modal = ref(null);

const props = defineProps(['claim']);

const approveClaim = async () => {
  await ApiClient.approveTalentPoolShiftClaim(props.claim.claim_id);
  modal.value.hide();
  const shifts = await getShiftsForTab(locationId, tab, true);
  if (shifts.length > 0) {
    router.push({
      name: 'talent-pool-shift-detail',
      params: { locationId, tab, shiftId: shifts[0].shift_id },
    });
  } else {
    router.push({
      name: 'talent-pool-shift-status',
      params: { locationId, tab },
    });
  }
};
</script>

<style scoped lang="scss">
.modal-container {
  background-color: var(--palette-color-base-background);
  padding: 0;
  display: flex;
  justify-content: space-around;
  border-radius: 0 0 8px 8px;
}

.left {
  margin: 0.8rem;
  margin-right: 0.4rem;
  background-color: var(--palette-color-base-white);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  padding: 0.75rem;
  height: fit-content;
}

.right {
  margin: 0.8rem;
  margin-left: 0.4rem;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.experience {
  background-color: var(--palette-color-base-white);
  border-radius: 8px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.heading {
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: -0.01em;
}

.info {
  display: flex;
  justify-content: space-between;
}

.subheading {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.01em;
}

.image-header {
  width: 100%;
}

.experience-text {
  margin: 0.5rem 0;
}

.pick-button {
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.companies {
  margin: 0.5rem 0;
}

.text {
  text-align: center;
  margin: 1rem 0;
}

.light-subheading {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.01em;
  text-align: left;
  color: var(--palette-color-default-lighten-30);
}

.small-light {
  color: var(--palette-color-default-lighten-30);
  font-size: 13px;
  line-height: 18px;
  letter-spacing: -0.01em;
}

.small-light-bold {
  color: var(--palette-color-default-lighten-30);
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: -0.01em;
}

.stat-bold {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.01em;
}

.experience-indiv {
  width: 100%;
  padding: 0 0.5rem 0.5rem 1rem;

  &:before {
    display: block;
    content: '';
    width: 0.75rem;
    height: 0.75rem;
    border-radius: 25px;
    position: relative;
    right: 1.25rem;
    top: 1rem;
    background-color: var(--palette-color-default-lighten-80);
  }
}

.logo {
  height: 75px;
  width: 75px;
  border: 1px solid var(--palette-color-default-lighten-90);
  border-radius: 25rem;
  object-fit: cover;
  position: relative;
}

.raise-logo {
  height: 1.5rem;
  margin: 1rem;
}

.rating-container {
  border: 1px solid var(--palette-color-default-lighten-90);
  border-radius: 12px;
  padding: 16px;
  width: 100%;
  margin-top: 1rem;
  align-items: center;
  text-align: center;
  display: flex;
  flex-direction: column;
}

.icon-overlay {
  margin-bottom: 0.5rem;
}
</style>
